<template>
    <a :href="'/blog/'+article.slug" class="blog-list__box" :style="'background-image: url('+article.obrazok+')'">
        <div class="box-content">
            <div class="box-date">{{article.datum}}</div>
            <h2 class="box-title">
                {{article.nazov}}
            </h2>
            <p class="box-text">
                {{article.perex}}
            </p>
        </div>
    </a>
</template>

<script>
export default {
    props:['article']
}
</script>

<style lang="scss" scoped>

</style>